import { Component } from 'vue-property-decorator';
import AbstractDisplayField from '../abstract-display-field/abstract-display-field';
import { mixins } from 'vue-class-component';

@Component({
  name: 'bpc-display-field-date',
  components: {},
})
export default class DisplayFieldDate extends mixins(AbstractDisplayField) {
  get formatDate(): string {
    return this.$bpcHelper.formatDate(this.value);
  }
}
